if (window.caches) {
    window.caches.keys().then(cacheKeys => {
        try {
            cacheKeys.forEach((cacheKey) => {
                return window.caches.delete(cacheKey);
            })
        } catch (err) {
            console.log(err)
        }
    });
}